import axios from "axios";
//import LocalStorageService from "./services/storage/localstorageservice";
import router from "../router";
var parse = require("json-parse-safe");

function getStoredAuthData() {
  const rawToken = localStorage.getItem("token");

  if (!rawToken) return null;

  const parsed = parse(<any>rawToken);

  if (parsed.value && parsed.value.token) return parsed.value;
  if (parsed.value && parsed.value.value && parsed.value.value.token) return parsed.value.value;
  if (typeof parsed.value === "string") return { token: parsed.value };

  return null;
}

function getStoredToken() {
  const authData = getStoredAuthData();

  return authData ? authData.token : null;
}

function getStoredRefreshToken() {
  const authData = getStoredAuthData();

  if (!authData) return null;

  return authData.refreshToken || authData.refresh_token || null;
}

function persistAuthData(data) {
  const tokenData = data && data.content ? data.content : data;

  if (tokenData && tokenData.token) {
    localStorage.setItem("token", JSON.stringify(tokenData));
  }

  return tokenData;
}

const runtimeVariables = (window as any).variables || {};
const runtimeApiBaseUrl = runtimeVariables.API_BASE_URL;

axios.defaults.baseURL =
  (runtimeApiBaseUrl && !runtimeApiBaseUrl.includes("${") ? runtimeApiBaseUrl : "") ||
  process.env.API_BASE_URL ||
  process.env.VUE_APP_API_URL ||
  "https://api.brizolaejapur.com.br";
// axios.defaults.baseURL = "http://localhost:3001";
// axios.defaults.baseURL = "http://localhost:3500";
// axios.defaults.baseURL = "https://rj123milhas-955db039f6df.herokuapp.com";
// axios.defaults.baseURL = "https://brizolaejapur-backend-api-0ba6563c28db.herokuapp.com/";
// axios.defaults.baseURL = "https://seal-app-5zuf2.ondigitalocean.app";

let refreshTokenRequest: Promise<string | null> | null = null;

async function refreshAccessToken() {
  if (!refreshTokenRequest) {
    refreshTokenRequest = new Promise((resolve, reject) => {
      const refreshToken = getStoredRefreshToken();

      if (!refreshToken) {
        reject(new Error("Refresh token não encontrado"));
        return;
      }

      axios
        .post("/api/admin/refresh-token", { refresh_token: refreshToken })
        .then((response) => {
          const tokenData = persistAuthData(response.data);
          resolve(tokenData ? tokenData.token : null);
        })
        .catch(reject)
        .finally(() => {
          refreshTokenRequest = null;
        });
    });
  }

  return refreshTokenRequest;
}

function redirectToLogin() {
  localStorage.clear();

  if (router.currentRoute.path !== "/login") {
    router.push("/login");
  }
}

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    const token = getStoredToken();

    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    // config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config || {};
    const originalRequestUrl = originalRequest.url || "";
    const status = error.response ? error.response.status : error.request ? error.request.status : null;

    if (status == 0) {
      return Promise.reject(error);
    }

    if (
      status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !originalRequestUrl.includes("/sessions") &&
      !originalRequestUrl.includes("/api/admin/login") &&
      !originalRequestUrl.includes("/api/admin/refresh-token")
    ) {
      originalRequest._retry = true;

      return refreshAccessToken()
        .then((token) => {
          if (!token) {
            redirectToLogin();
            return Promise.reject(error);
          }

          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers["Authorization"] = "Bearer " + token;
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          return axios(originalRequest);
        })
        .catch((refreshError) => {
          redirectToLogin();
          return Promise.reject(refreshError);
        });
    }

    if (
      status === 401 &&
      originalRequest &&
      !originalRequestUrl.includes("/api/admin/login")
    ) {
      redirectToLogin();
      return Promise.reject(error);
    }

    // if (error.response.status === 419 && !originalRequest._retry) {
    //   originalRequest._retry = true;
    //   const token = parse(<any>localStorage.getItem("token"));

    //   return axios
    //     .get(
    //       `/sessions/${token.value.session}/access/new?access=${token.value.access}`
    //     )
    //     .then((res) => {
    //       if (res.status === 200) {
    //         localStorage.setItem("token", JSON.stringify(res.data.data));
    //         axios.defaults.headers.common["Authorization"] =
    //           "Bearer " + res.data.data.access;
    //       }
    //       return axios(originalRequest);
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //       router.push("/login");
    //       return Promise.reject(error);
    //     });
    // }

    //check error format
    if (error.response && error.response.data && "success" in error.response.data) {
      return Promise.reject(error.response.data);
    }

    return Promise.reject(error);
  }
);
